<template>
  <div class="page-farm-yiled">
    <div class="card card-custom dashboard-farm-controller">
      <!--begin::Header-->
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body pt-0" style="padding: 1rem 1.5rem;">
        <div class="as-tabs">
          <b-tabs>
            <b-tab v-for="(item, i) in contentTap.content" :key="i" :active="i == contentTap.tableState" @click="changeConnect(i)">
              <template slot="title">
                <span class="nav-text font-weight-bold font-size-h6 font-size-h4-lg">{{ item }}</span>
              </template>
            </b-tab>
            <div class="card-toolbar toolbar-symbol">
              <!-- 파종등록버튼 -->
              <b-button v-show='contentTap.tableState == 0' variant="dark" class="rounded-sm float-right" size="sm" @click='showRegistrationModal()'>{{i18n.workRegistration}}</b-button>
              <!-- 특이사항 등록버튼 -->
              <b-button v-show='contentTap.tableState == 1' variant="dark" class="rounded-sm float-right" size="sm" @click='showSpecialNoteRegistrationModal(null)'>{{i18n.specialNoteRegistration}}</b-button>
            </div>
            <!--생산 실적관리 테이블 시작 -->
            <div v-show="contentTap.tableState == 0" class="yielPlanInfo-table mt-4">
              <div class="row mb-2">
                <!-- 작물명 -->
                <div class="form-inline col-xxl-2 col-lg-4 mb-3">
                  <label class="text font-size-h6 font-weight-bold mr-5"> 
                    {{i18n.cropName}}
                  </label>
                  <b-form-select 
                    v-model="filterCrop.cropNo" 
                    :options="filterCrop.cropNmList" 
                    style="width: 145px;" 
                    class="disabled-white"
                    @change="[paging.pageNo=1, linkGen(), getYieldManagement(null)]"
                  />
                </div>
                <!-- 시작일 -->
                <div class="form-inline col-xxl-2 col-lg-4 mb-3">
                  <label class="text font-size-h6 font-weight-bold mr-5"> {{i18n.startDate}} </label>
                  <b-form-datepicker
                    v-model="managementYmd.startYmd"
                    :locale="locale"
                    class="farm-custom-datepicker"
                    placeholder=""
                    style="width: 145px"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    @input="[paging.pageNo=1, linkGen(), getYieldManagement(null)]"
                  ></b-form-datepicker>
                </div>
                <!-- 종료일 -->
                <div class="form-inline col-xxl-2 col-lg-4 mb-3">
                  <label class="text font-size-h6 font-weight-bold mr-5"> {{i18n.endDate}} </label>
                  <b-form-datepicker
                    v-model="managementYmd.endYmd"
                    :locale="locale"
                    class="farm-custom-datepicker"
                    placeholder=""
                    style="width: 145px"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    @input="[paging.pageNo=1, linkGen(), getYieldManagement(null)]"
                  ></b-form-datepicker>
                </div>
                <!-- ~~일 기준 -->
                <div class="form-inline col-xxl-3 col-lg-4 mb-3">
                  <span class="text font-weight-bold text-primary">{{i18n.workDate}} : {{`${filterCrop.cropNmList.filter(crop => crop.value == this.filterCrop.cropNo)[0].text} ${managementYmd.startYmd == null ? '':managementYmd.startYmd} ~ ${managementYmd.endYmd == null ? '':managementYmd.endYmd}`}}</span>
                </div>

                <!-- 엑셀 -->
                <div class="form-inline col-xxl-3 col-lg-4 mb-3">
                  <span class="text font-size-h6 font-weight-bold mr-5">{{i18n.downloadExcel}}</span>
                  <button v-if="!isMobile" button @click="onDownloadExcel()">
                    <i class="far fa-file-excel"></i>
                  </button>
                </div>
              </div>
              <!-- 실적 표 -->
              <v-data-table
                :items="managementList"
                item-key="yieldManagementNo"
                class="elevation-1 farm-data-table"
                :no-data-text="`${i18n.noData}`"
                hide-default-footer
                single-expand
                :items-per-page="paging.pageSize"
                height="490px"
                style="cursor: pointer;"
                :mobile-breakpoint="0"
              >
                <!-- 헤더 -->
                <template v-slot:header>
                  <thead class="scrollable-sticky">
                    <tr>
                      <th v-for="(header, index) in yieldFirstColumn"
                        :key="index"
                        :rowspan="header.span === 'row' ? header.number : null"
                        :colspan="header.span === 'col' ? header.number : null"
                        :class="['text-center', `sticky-col-${index}`]"
                        :style="index === 0 ? 'width: 100px; min-width: 100px;' : ''"
                      >
                        {{ header.text }}
                      </th>
                    </tr>
                    <tr>
                      <th v-for="(header, index) in yieldSecondColumn" :key="index" :style="{ width: header.width }" class="text-center">{{ header.text }}</th>
                      <th>{{ i18n.productionProcess }}</th>
                    </tr>
                  </thead>
                </template>
                <!-- 바디 -->
                <template v-slot:item="{ item }">
                  <tr v-if="item" @click="showPerformanceRegistrationModal(item)">
                    <td>{{ item.workDate }}</td>
                    <td>{{ locale === 'ko' ? item.cropNm: item.cropNmEn }}</td>
                    
                    <td v-for="(header, index) in yieldSecondColumn" :key="index" :class="header.css" :style="{ width: header.width }">
                      {{ item[header.value] }}
                    </td>
                    <td>
                      <button v-if="item.harvestNo !== null && item.harvestNo !== undefined" @click.stop="onClickProcessButton(item)" class="btn btn-secondary">
                        {{ i18n.look }}
                      </button>
                    </td> 
                    <td>{{ item.createDt }}</td> 
                    <td>{{ item.memberNm }}</td> 
                  </tr>
                  <tr v-else>
                    <td colspan="100%" class="text-center">
                      {{ i18n.noData }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <!-- 페이징 시작 -->
              <div v-if="totalPage" class="pagination mt-3">
                <b-pagination-nav
                  :number-of-pages="totalPage"
                  :link-gen="linkGen"
                  use-router
                  limit="10"
                >
                  <template #first-text><i class="fas fa-angle-double-left"></i></template>
                  <template #prev-text><i class="fas fa-angle-left"></i></template>
                  <template #next-text><i class="fas fa-angle-right"></i></template>
                  <template #last-text><i class="fas fa-angle-double-right"></i></template>
                  <template #page="{ page, active }">
                    <span v-if="active" class="font-size-sm font-weight-bold text-white">{{ page }}</span>
                    <span v-else class="font-size-sm font-weight-bold text-dark">{{ page }}</span>
                  </template>
                </b-pagination-nav>
              </div>
            <!-- 페이징 끝 -->
            </div>
            <!-- 생산 실적관리 테이블 끝 -->

            <!--특이사항 테이블 시작 -->
            <div v-show="contentTap.tableState == 1" class="yielPlanInfo-table mt-4">
              <div class="row mb-2">
                <!-- 시작일 -->
                <div class="form-inline col-xxl-2 col-lg-4 mb-3">
                  <label class="text font-size-h6 font-weight-bold mr-5"> {{i18n.startDate}} </label>
                  <b-form-datepicker
                    v-model="specialNoteStartYmd"
                    :locale="locale"
                    class="farm-custom-datepicker"
                    placeholder=""
                    style="width: 145px"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    @input="[specialNotePaging.pageNo=1, getSpecialNote(), spcicalLinkGen()]"
                  ></b-form-datepicker>
                </div>
                <!-- 종료일 -->
                <div class="form-inline col-xxl-2 col-lg-4 mb-3">
                  <label class="text font-size-h6 font-weight-bold mr-5"> {{i18n.endDate}} </label>
                  <b-form-datepicker
                    v-model="specialNoteEndYmd"
                    :locale="locale"
                    class="farm-custom-datepicker"
                    placeholder=""
                    style="width: 145px"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    @input="[specialNotePaging.pageNo=1, getSpecialNote(), spcicalLinkGen()]"
                  ></b-form-datepicker>
                </div>

                <!-- 엑셀 -->
                <div class="form-inline col-xxl-3 col-lg-4 mb-3">
                  <span class="text font-size-h6 font-weight-bold mr-5">{{i18n.downloadExcel}}</span>
                  <button v-if="!isMobile" button @click="onSpecialDownloadExcel()">
                    <i class="far fa-file-excel"></i>
                  </button>
                </div>
              </div>
              <!-- 실적 표 -->
              <v-data-table
                :items="specialNoteItemList"
                item-key="specialNoteNo"
                class="elevation-1 farm-data-table"
                :no-data-text="`${i18n.noData}`"
                hide-default-footer
                single-expand
                :items-per-page="specialNotePaging.pageSize"
                height="490px"
              >
              <!-- 헤더 -->
              <template v-slot:header>
                <thead class="scrollable-sticky">
                  <tr>
                    <th v-for="(header, index) in specialNoteColumn"
                      :key="index"
                      class="text-center"
                      :style="{ width: header.width }"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </thead>
              </template>
              <template v-slot:item="{ item }">
                <tr @click="specialNoteClick(item)" style="cursor: pointer;">
                  <td>{{ item.specialNoteDate }}</td>
                  <td class="text-truncate">{{ item.growth }}</td>
                  <td class="text-truncate">{{ item.facility }}</td>
                  <td class="text-truncate">{{ item.recoveryActivity }}</td>
                  <td class="text-truncate">{{ item.test }}</td>
                  <td class="text-truncate">{{ item.etc }}</td>
                  <td class="text-truncate">{{ item.comment }}</td>
                  <td class="text-truncate">{{ item.createDt }}</td>
                  <td class="text-truncate">{{ item.memberNm }}</td>
                </tr>
              </template>
              </v-data-table>
              <!-- 바디 -->
              <!--begin::pagination-->
              <div v-if="specialNoteTotalPage" class="pagination mt-3">
                <b-pagination-nav
                  :number-of-pages="specialNoteTotalPage"
                  :link-gen="spcicalLinkGen"
                  use-router
                  limit="10"
                >
                  <template #first-text><i class="fas fa-angle-double-left"></i></template>
                  <template #prev-text><i class="fas fa-angle-left"></i></template>
                  <template #next-text><i class="fas fa-angle-right"></i></template>
                  <template #last-text><i class="fas fa-angle-double-right"></i></template>
                  <template #page="{ page, active }">
                    <span v-if="active" class="font-size-sm font-weight-bold text-white">{{ page }}</span>
                    <span v-else class="font-size-sm font-weight-bold text-dark">{{ page }}</span>
                  </template>
                </b-pagination-nav>
              </div>
            <!--end::pagination-->
            </div>
            <!-- 이슈 테이블 끝 -->
          </b-tabs>
        </div>
      </div>
      <!--end::Body-->
    </div>
    
    <!-- 실적 입력 모달 -->
    <YieldManagementRegistraionModal v-if="farmInfo"
      :farmInfo="farmInfo"
      :registrationModal ="registrationModal" 
      :cropNmList = "registrationSowing.cropNmList"
      :selectYieldManagement = "selectYieldManagement"
      @registrationModalUpdate="registrationModalUpdate"
      @regist="regist"
    ></YieldManagementRegistraionModal>    

    <!-- 프로세스 모달 -->
    <YieldManagementProcessModal v-if="processModal"
      :processModal="processModal"
      :processList="processList"
      @processClose="processModal = false"
    ></YieldManagementProcessModal>    

    <!-- 특이사항 모달 시작 -->
    <b-modal
      v-model="specialNoteModal"
      size="xl"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <div class="card card-custom card-stretch">
      <!--begin::Header-->
      <div class="card-header border-0 align-items-center">
        <h3 class="card-title align-items-start flex-column">
          <span  class="title font-weight-bold" v-if="specialNoteNo === null">
            {{ i18n.specialNoteRegistration }}
          </span>
          <span  class="title font-weight-bold" v-else>
            {{ i18n.specialNoteUpdate }}
          </span>
        </h3>
        <div class="card-toolbar toolbar-symbol">
          <b-button variant="dark" class="btn-icon rounded-lg" size="sm" @click="specialNoteModal = false">
            <i class="la la-close font-size-h5"></i>
          </b-button>
        </div>
      </div>
      <!--end::Header-->
      <!-- begin::Body -->
      <div class="card-body pt-5">
        <div class="form-group row mb-4">
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.registeredDate}}</span>
          </label>
          <div class="col-sm-4">
            <b-form-datepicker
              v-model="specialNoteDate"
              menu-class="w-"
              calendar-width="100%"
              class="mb-2 disabled-white"
              :locale="locale"
              :placeholder="`${i18n.yearMonthDay}`"
            ></b-form-datepicker>
          </div>
        </div>
        <div class="form-group row mb-4">
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.growth}}</span>
          </label>
          <div class="col-sm-4" >
            <textarea v-model="growth" type="text" maxlength="500" class="farm-form-control form-control form-control-lg"  style="height: 100px; resize: none;"></textarea>
          </div>
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.facility}}</span>
          </label>
          <div class="col-sm-4" >
            <textarea v-model="facility" type="text" maxlength="500" class="farm-form-control form-control form-control-lg"  style="height: 100px; resize: none;"></textarea>
          </div>
        </div>
        <div class="form-group row mb-4">
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.recoveryActivity}}</span>
          </label>
          <div class="col-sm-4" >
            <textarea v-model="recoveryActivity" type="text" maxlength="500" class="farm-form-control form-control form-control-lg"  style="height: 100px; resize: none;"></textarea>
          </div>
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.test}}</span>
          </label>
          <div class="col-sm-4" >
            <textarea v-model="test" type="text" maxlength="500" class="farm-form-control form-control form-control-lg"  style="height: 100px; resize: none;"></textarea>
          </div>
        </div>
        <div class="form-group row mb-4">
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.etc}}</span>
          </label>
          <div class="col-sm-4" >
            <textarea v-model="etc" type="text" maxlength="500" class="farm-form-control form-control form-control-lg"  style="height: 100px; resize: none;"></textarea>
          </div>
          <label class="col-sm-2 col-form-label">
            <span class="h5">{{i18n.comment}}</span>
          </label>
          <div class="col-sm-4" >
            <textarea v-model="comment" type="text" maxlength="500" disabled class="farm-form-control form-control form-control-lg"  style="height: 100px; resize: none;"></textarea>
          </div>
        </div>

      </div>
      <!--begin::Footer-->
      <div class="card-footer">
        <b-button v-if="specialNoteNo === null" variant="primary" size="lg" @click="insertSpecialNote()"><span >{{ i18n.specialNoteRegistration }}</span></b-button>
        <div v-else>
          <b-button variant="primary" size="lg" @click="updateSpecialNote()"><span >{{ i18n.specialNoteUpdate }}</span></b-button>
          <b-button variant="secondary" size="lg" class="ml-3" @click="deleteSpecialNote()"><span >{{ i18n.specialNoteDelete }}</span></b-button>
        </div>
      </div>
      <!--end::Footer-->
      </div>
    </b-modal>
    <!-- 특이사항 모달 종료 -->

    <!-- 실적 엑셀 다운로드 시작 -->
    <div v-show="false">
      <v-data-table
        :items="managementListExcel"
        item-key="yieldManagementNo"
        class="elevation-1 farm-data-table"
        :no-data-text="`${i18n.noData}`"
        hide-default-footer
        hide-default-header
        single-expand
        :items-per-page="-1"
        id="yield_table"
      >
       <!-- 헤더 -->
        <template v-slot:header>
          <thead class="scrollable-sticky">
            <tr>
              <th v-for="(header, index) in yieldFirstExcelColumn"
                :key="index"
                :rowspan="header.span === 'row' ? header.number : null"
                :colspan="header.span === 'col' ? header.number : null"
                :class="['text-center', `sticky-col-${index}`]"
                :style="index === 0 ? 'width: 100px; min-width: 100px;' : ''"
              >
                {{ header.text }}
              </th>
            </tr>
            <tr>
              <th v-for="(header, index) in yieldSecondColumn" :key="index" :style="{ width: header.width }" class="text-center">{{ header.text }}</th>
              <!-- <th>{{ i18n.productionProcess }}</th> -->
            </tr>
          </thead>
        </template>
        <!-- 바디 -->
        <template v-slot:item="{ item }">
          <tr v-if="item" @click="showPerformanceRegistrationModal(item)">
            <td>{{ item.workDate }}</td>
            <td>{{ locale === 'ko' ? item.cropNm: item.cropNmEn }}</td>
            
            <td v-for="(header, index) in yieldSecondColumn" :key="index" :class="header.css" :style="{ width: header.width }">
              {{ item[header.value] }}
            </td>
            <!-- <td>
              <button @click.stop="onClickButton(item)" class="btn btn-secondary">
                보기
              </button>
            </td>  -->
            <td>{{ item.createDt }}</td> 
            <td>{{ item.memberNm }}</td> 
          </tr>
          <tr v-else>
            <td colspan="100%" class="text-center">
              {{ i18n.noData }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <!-- 실적 엑셀 다운로드 종료 -->

    <!-- 특이사항 엑셀 다운로드 시작 -->
    <div v-show="false">
      <v-data-table
        :items="specialNoteItemListExcel"
        item-key="specialNoteNo"
        class="elevation-1 farm-data-table"
        :no-data-text="`${i18n.noData}`"
        hide-default-footer
        hide-default-header
        single-expand
        :items-per-page="-1"
        id="special_table"
      >
      <!-- 헤더 -->
      <template v-slot:header>
        <thead class="scrollable-sticky">
          <tr>
            <th v-for="(header, index) in specialNoteColumn"
              :key="index"
              class="text-center"
              :style="{ width: header.width }"
            >
              {{ header.text }}
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.specialNoteDate }}</td>
          <td class="text-truncate">{{ item.growth }}</td>
          <td class="text-truncate">{{ item.facility }}</td>
          <td class="text-truncate">{{ item.recoveryActivity }}</td>
          <td class="text-truncate">{{ item.test }}</td>
          <td class="text-truncate">{{ item.etc }}</td>
          <td class="text-truncate">{{ item.comment }}</td>
          <td class="text-truncate">{{ item.createDt }}</td>
          <td class="text-truncate">{{ item.memberNm }}</td>
        </tr>
      </template>
      </v-data-table>
    </div>
    <!-- 특이사항 엑셀 다운로드 종료 -->

  </div>
  
</template>
  
<script>
  import {SET_BREADCRUMB} from '@/core/services/store/breadcrumbs.module';
  import {ACT_GET_MY_FARM,
  ACT_GET_YIELD_MANAGEMENT,
  ACT_GET_YIELD_MANAGEMENT_PROCESS,
  ACT_INSERT_YIELD_SPECIAL_NOTE,
  ACT_GET_YIELD_SPECIAL_NOTE,
  ACT_UPDATE_YIELD_SPECIAL_NOTE,
  ACT_DELETE_YIELD_SPECIAL_NOTE,
  ACT_GET_YIELD_REGIST_CROP,
  } from '@/core/services/variable';
  import {isSuccess, getResult, lan, utcToDate, timestampToDate, getTimeDifference, nullOrUndefinedCheck} from '@/core/services/funcs';
  import {ACT_ADD_ALERT, ACT_SHOW_CONFIRM_ALERT} from '@/core/services/store/alert.module';
  import i18n from '@/core/plugins/vue-i18n.js';
  import Vue from "vue";
  import {mapGetters} from 'vuex';
  import {Paging} from '@/view/model/PagingModel.js'
  import YieldManagementRegistraionModal from '@/components/modal/YieldManagementRegistraionModal';
  import YieldManagementProcessModal from '@/components/modal/YieldManagementProcessModal';
  import * as XLSX from 'xlsx'
  
  export default {
    name: "YieldManagemnet",
    components: {
      YieldManagementRegistraionModal,
      YieldManagementProcessModal
    },
    data() {
      return {
         i18n: {
          cropName: i18n.t('farm.yield.cropNm'),
          startDate: i18n.t('farm.yield.start'),
          endDate: i18n.t('farm.yield.end'),
          register: i18n.t('farm.cultivationCrop.register'),
          yearMonthDay: i18n.t('farm.yield.yearMonthDay'),
          noData: i18n.t('farm.yield.noData'),
          look: i18n.t('farm.yield.look'),
          workRegistration : i18n.t('farm.yield.workRegistration'), // 작업 등록
          asOfSowingDate: i18n.t('farm.yield.asOfSowingDate'), // 파종일 기준
          yieldRegistration: i18n.t('farm.yield.yieldRegistration'), // 실적 등록
          specialNote: i18n.t('farm.yield.specialNote'), // 특이사항
          specialNoteRegistration: i18n.t('farm.yield.specialNoteRegistration'), // 특이사항 등록
          specialNoteUpdate: i18n.t('farm.yield.specialNoteUpdate'), // 특이사항 수정
          specialNoteDelete: i18n.t('farm.yield.specialNoteDelete'), // 특이사항 수정
          registeredDate: i18n.t('farm.yield.registeredDate'), // 등록일시
          all : i18n.t('farm.yield.all'), // 전체
          growth : i18n.t('farm.yield.growth'), // 생육
          facility : i18n.t('farm.yield.facility'), // 시설
          recoveryActivity : i18n.t('farm.yield.recoveryActivity'), // 정상화활동
          test : i18n.t('farm.yield.test'), // test
          etc : i18n.t('farm.yield.etc'), // 기타
          comment : i18n.t('farm.yield.comment'), // 정상화활동
          writer : i18n.t('farm.yield.writer'), // 작성자
          productionProcess: i18n.t('farm.yield.productionProcess'), // 생성공정 
          workDate: i18n.t('farm.yield.workDate'), // 생성공정 
          // 오류창
          rightValue: i18n.t('farm.yield.rightValue'),
          confirm: i18n.t('farm.yield.confirm'),

          error: i18n.t('farm.yield.error'),
          deleteAlert: i18n.t('farm.yield.deleteAlert'),

          downloadExcel: i18n.t('farm.yield.downloadExcel'),// 엑셀다운 
        },
        timeZone : Intl.DateTimeFormat().resolvedOptions().timeZone,
        farmInfo: null,
        // 생산 실적 관리, 특이사항 탭
        contentTap : { 
          content : [i18n.t('topNavBar.farm.yieldInfo'), i18n.t('farm.yield.specialNote')], // 탭 이름
          tableState: 0, // 탭 상태
        },
        // 생산 실적 리스트
        managementList : [], 
        // 생산 실적 엑셀 다운 리스트
        managementListExcel : [], 
         // 생산 실적 일자
        managementYmd : {
          startYmd : null,
          endYmd : null,
        }, 
        // 표 조회 필터링 작물
        filterCrop : { 
          cropNo : 0, 
          cropNmList : [{value:0, text:`${i18n.t('farm.yield.allCrops')}`}],
        },
        // 표 페이징
        paging : new Paging(1, 150, 1, false),
        
        // 실적 클릭한 row 정보보
        selectYieldManagement : null, 
        // 파종 등록 데이터
        registrationSowing : { 
          sowingRate: null
        },
        // 이식 업데이트 데이터
        updateTransplant : {
          transplantRate: 0, // 이식율 /
        },
        // 정식 업데이트 데이터
        updatePlantDate : {
          plantingRate: 0, // 정식율 
        },
        // 수확 업데이트 데이터
        updateHarvestDate : {
          weightPerPlant: 0, // 포기당 중량 
          discardRate: 0, // 폐기율 
          achievementRate: 0, // 달성율 
        },
  
        // 테이블 컬럼명
        yieldFirstColumn: [
          { value: 'workDate', text: i18n.t('farm.yield.workDate'), span: 'row', number: 2}, // 작업일
          { value: 'cropNm', text: i18n.t('farm.yield.cropNm'), span: 'row', number: 2}, // 작물명
          
          { value: 'sowing', text: i18n.t('farm.yield.sowing'), span: 'col', number: 3}, // 파종
          { value: 'seedling', text: i18n.t('farm.yield.seedling'), span: 'col', number: 4}, // 육묘
          { value: 'transplant', text: i18n.t('farm.yield.transplant'), span: 'col', number: 5}, // 이식
          { value: 'plant', text: i18n.t('farm.yield.plant'), span: 'col', number: 6}, // 정식
          { value: 'harvest', text: i18n.t('farm.yield.harvest'), span: 'col', number: 14}, // 수확
          
          { value: 'createDt', text: i18n.t('farm.yield.createDt'), span: 'row', number: 2}, // 최초등록일자
          { value: 'memberNm', text: i18n.t('farm.yield.writer'), span: 'row', number: 2}, // 작성자
        ],
        yieldFirstExcelColumn: [
          { value: 'workDate', text: i18n.t('farm.yield.workDate'), span: 'row', number: 2}, // 작업일
          { value: 'cropNm', text: i18n.t('farm.yield.cropNm'), span: 'row', number: 2}, // 작물명
          
          { value: 'sowing', text: i18n.t('farm.yield.sowing'), span: 'col', number: 3}, // 파종
          { value: 'seedling', text: i18n.t('farm.yield.seedling'), span: 'col', number: 4}, // 육묘
          { value: 'transplant', text: i18n.t('farm.yield.transplant'), span: 'col', number: 5}, // 이식
          { value: 'plant', text: i18n.t('farm.yield.plant'), span: 'col', number: 6}, // 정식
          { value: 'harvest', text: i18n.t('farm.yield.harvest'), span: 'col', number: 13}, // 수확
          
          { value: 'createDt', text: i18n.t('farm.yield.createDt'), span: 'row', number: 2}, // 최초등록일자
          { value: 'memberNm', text: i18n.t('farm.yield.writer'), span: 'row', number: 2}, // 작성자
        ],
        yieldSecondColumn: [
          // 파종
          
          { value: 'usedSowingTray', text: i18n.t('farm.yield.usedSowingTray')}, // 사용 파종판
          { value: 'sowingTotalCapa', text: i18n.t('farm.yield.sowingTotalCapa')}, // 파종 총 Capa
          { value: 'sowingRate', text: i18n.t('farm.yield.sowingRate')}, // 파종율
          // 육묘
          { value: 'seedlingWorkDate', text: i18n.t('farm.yield.sowingDate')}, // 파종일
          { value: 'seedlingUsedSeedlingTray', text: i18n.t('farm.yield.usedSeedlingTray')}, // 사용모판
          { value: 'seedlingTotalCapa', text: i18n.t('farm.yield.seedlingTotalCapa')}, // 육묘 총 Capa
          { value: 'germinationRate', text: i18n.t('farm.yield.germinationRate')}, // 발아율
          // 이식
          { value: 'transplantWorkDate', text: i18n.t('farm.yield.sowingDate')}, // 파종일
          { value: 'transplantUsedSeedlingTray', text: i18n.t('farm.yield.usedSeedlingTray')}, // 사용모판
          { value: 'usedTransplantTray', text: i18n.t('farm.yield.usedTransplantTray')}, // 사용이식판
          { value: 'transplantTotalCapa', text: i18n.t('farm.yield.transplantTotalCapa')}, // 이식 총 Capa
          { value: 'transplantRate', text: i18n.t('farm.yield.transplantRate')}, // 이식율
          // 정식
          { value: 'plantWorkDate', text: i18n.t('farm.yield.sowingDate')}, // 파종일
          { value: 'plantUsedTransplantTray', text: i18n.t('farm.yield.usedTransplantTray')}, // 사용이식판
          { value: 'usedPlantingTray', text: i18n.t('farm.yield.usedPlantingTray')}, // 사용정식판
          { value: 'plantingTotalCapa', text: i18n.t('farm.yield.plantingTotalCapa')}, // 정식 총 Capa
          { value: 'farmRackNameList', text: i18n.t('farm.yield.plantingArea'), width: '500px', css: 'scrollable-text'}, // 정식 구역
          { value: 'plantingRate', text: i18n.t('farm.yield.plantingRate')}, // 정식율
          // 수확
          { value: 'harvestWorkDate', text: i18n.t('farm.yield.sowingDate')}, // 파종일
          { value: 'cultivationDays', text: i18n.t('farm.yield.cultivationDays')}, // 재배기간
          { value: 'numberOfPlants', text: i18n.t('farm.yield.numberOfPlants')}, // 포기수
          { value: 'rootMaterial', text: i18n.t('farm.yield.rootMaterial')}, // 뿌리원물
          { value: 'weightPerPlant', text: i18n.t('farm.yield.weightPerPlant')}, // 포기당 중량
          { value: 'harvestYield', text: i18n.t('farm.yield.harvestYield')}, // 수확량
          { value: 'targetHarvestYield', text: i18n.t('farm.yield.targetHarvestYield')}, // 목표 수확량
          { value: 'targetWeightPerPlant', text: i18n.t('farm.yield.targetWeightPerPlant')}, // 목표 포기당 중량
          { value: 'excludingHarvestYield', text: i18n.t('farm.yield.excludingHarvestYield')}, // 제외수확량

          { value: 'numberOfDiscards', text: i18n.t('farm.yield.numberOfDiscards')}, // 폐기수
          { value: 'gradeARate', text: i18n.t('farm.yield.gradeARate')}, // A급 비율
          { value: 'discardRate', text: i18n.t('farm.yield.discardRate')}, // 폐기율
          { value: 'achievementRate', text: i18n.t('farm.yield.achievementRate')}, // 달성율
        ],
        // 특이사항 컬럼
        specialNoteColumn: [
          { value: 'specialNoteDate', text: i18n.t('farm.yield.registeredDate'), width: '80px' }, // 등록일시
          { value: 'growth', text: i18n.t('farm.yield.growth'), width: '200px'}, // 생육
          { value: 'facility', text: i18n.t('farm.yield.facility'), width: '200px'}, // 이슈 
          { value: 'recoveryActivity', text: i18n.t('farm.yield.recoveryActivity'), width: '200px'}, // 정상화활동
          { value: 'test', text: i18n.t('farm.yield.test'), width: '200px'}, // test
          { value: 'etc', text: i18n.t('farm.yield.etc'), width: '200px'}, // 기타
          { value: 'comment', text: i18n.t('farm.yield.comment'), width: '200px'}, // 코멘트
          { value: 'createDt', text: i18n.t('farm.yield.createDt'), width: '80px'}, // 최초등록일자
          { value: 'memberNm', text: i18n.t('farm.yield.writer'), width: '80px'}, // 작성자
        ],
  
        // 실적등록 모달
        registrationModal: false, // 여기서 사용
        usedSowingTray: 0, // 사용 파종판
  
        fno: 0,
        farmNm: '',
        
        specialNotePaging : new Paging(1, 150, 1, false),

        locale: 'ko',
        processModal: false, // 생산실적 관리 모달
        processList: [], // 생산실적 프로세스에서 보여줄 리스트
  
        // 특이사항
        specialNoteModal : false,
        specialNoteDate : null,
        growth : null,
        facility : null,
        recoveryActivity : null,
        test : null,
        etc : null,
        comment : null,
        specialNoteStartYmd: null,
        specialNoteEndYmd: null,
        specialNoteItemList : [],
        specialNoteItemListExcel : [],
        specialNoteNo: null
      }
    },
    beforeMount(){
      this.changeFixedDate(60)
      if(Object.keys(i18n._localeChainCache)[0] == 'en'){
        this.locale = 'en'
      }

      this.init()

      // 입력되었던 전체 작물 명 조회
      this.getRegistCrop()
  
      // 파종일, 육묘일,이식일, 정식일, 수확일 기본으로 현재일자 셋팅
      this.setTodayDate()

      // 실적 조회
      this.getYieldManagement(null)

      // 특이사항 조회 
      this.getSpecialNote()
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [{ title: `${i18n.t('topNavBar.farm.farmYield')}`, icon: 'fas fa-clipboard' }, { title: `${i18n.t('farm.yield.yieldManagement')}` }]);
      window.scrollTo(0,0);
    },
    created() {

      if(this.$route.query.page) this.paging.pageNo = this.$route.query.page;
      if(this.$route.query.specialPage) this.specialNotePaging.pageNo = this.$route.query.specialPage;

      
    },
    watch: {
      '$route' (to) {
        // 생산실적
        if(to.query.page){
          this.paging.pageNo = to.query.page;
          this.getYieldManagement(null)
          
        }else {
          this.paging.pageNo = 1
          this.getYieldManagement(null)
        }
        // 특이사항
        if(to.query.specialNotePage){
          this.specialNotePaging.pageNo = to.query.specialNotePage;
          this.getSpecialNote()
        }else{
          this.specialNotePaging.pageNo = 1
          this.getSpecialNote()
        }
      },

    },
    computed: {
      ...mapGetters(["isMobile"]),
      totalPage() {
        if(this.paging){
          return Math.ceil(this.paging.totalCount / this.paging.pageSize);
        }
        return 0;
      },
      specialNoteTotalPage() {
        if(this.specialNotePaging){
          return Math.ceil(this.specialNotePaging.totalCount / this.specialNotePaging.pageSize);
        }
        return 0;
      },
    },
    methods: {
      async init(){
        await this.$store.dispatch(ACT_GET_MY_FARM).then(resp => {
          this.fno = resp.items[0].fno
          this.farmNm = resp.items[0].farmNm
          this.farmInfo = resp.items[0]
  
        })
      },
      // 자식 컴포넌트에서 등록 되었을때 전달 받기
      regist(value){
        this.filterCrop.cropNo = 0
        this.getYieldManagement(value)
        this.getRegistCrop()
      },

      // 입력되었던 전체 작물 명 조회
      getRegistCrop() {
        // this.filterCrop.cropNmList는 입력되었던 전체 작물 명
        this.$store.dispatch(ACT_GET_YIELD_REGIST_CROP).then(resp => {
          this.filterCrop.cropNmList=[{value:0, text:`${i18n.t('farm.yield.allCrops')}`}]
          resp.items.forEach( item => {
            this.filterCrop.cropNmList.push({value:item.cropNo ,text: lan() == 'ko' ? item.cropNm : item.cropNmEn})
        })
      })
      },

      onClickProcessButton(valus){
        this.processList = []
        this.processModal = true
        this.$store.dispatch(ACT_GET_YIELD_MANAGEMENT_PROCESS, valus).then((resp) =>{
          this.processList = resp.items;
          
        })

      },
      // 생산실적 조회
      getYieldManagement(valus){
       
        const params = {
          startYmd : this.managementYmd.startYmd,
          endYmd : this.managementYmd.endYmd,
          pageNo : this.paging.pageNo,
          pageSize: this.paging.pageSize,
          cropNo : this.filterCrop.cropNo
        }
        this.$store.dispatch(ACT_GET_YIELD_MANAGEMENT, params).then((resp) =>{
         
          // resp.items.forEach(item => {
          //   item.cultivationDays = this.getGrowingDays(item)
          // })
 
          //영문

          this.managementList = resp.items;
          this.paging.totalCount = resp.paging.totalCount
          
        })
      },
      /**
       * 재배일 수 계산
       */
      getGrowingDays(item) {
        if (item.harvestWorkDate === null || item.harvestWorkDate === undefined || item.harvestWorkDate === '') {
          return null;
        }

        const growingArr = [];
        // 날짜만 가져오기
        const totalCapaList = item.harvestWorkDate.split('/').map(s => s.trim());
        totalCapaList.forEach((value, index) => {
          const sow = new Date(value);
          const harvest = new Date(item.workDate);
          const diffInDays = Math.round((harvest - sow) / (1000 * 60 * 60 * 24));
          growingArr.push(diffInDays);
        });

        return growingArr.join(',');
      },
      // 실적 등록 모달 
      showRegistrationModal(){
        // 모달 on/off
        this.selectYieldManagement = null // 등록이면 null
        this.registrationModal = true
        
      },
      //  표 클릭(수정) 모달 on/off
      showPerformanceRegistrationModal(item){
        this.selectYieldManagement = item
        this.registrationModal = true
      },
      // 모달 on/off 전달받았을 시
      registrationModalUpdate(vlaue){
        this.registrationModal = vlaue
        // 수정모달off일시 객체 초기화
        if(vlaue === false) {
          this.selectYieldManagement = null
        }
      },
 

      // 특이사항 등록 버튼 클릭 모달창 오픈
      showSpecialNoteRegistrationModal(value){
        if(value === null || value === undefined) {
          this.growth = null
          this.facility = null
          this.recoveryActivity = null
          this.test = null
          this.etc = null
          this.comment = null
        }

        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 1);
        this.specialNoteDate = utcToDate(currentDate, 'yyyy-MM-dd')
        this.specialNoteNo = null
        this.specialNoteModal = true
      },
      // 특이사항 등록
      insertSpecialNote() {

        let params = {
          specialNoteDate : this.specialNoteDate,
          fno: this.fno,
          growth : this.growth,
          facility : this.facility,
          recoveryActivity : this.recoveryActivity,
          test : this.test,
          etc : this.etc
        }
        // 유효성 검증
        if(nullOrUndefinedCheck(params.specialNoteDate) === null || 
          (
            nullOrUndefinedCheck(params.growth) === null && 
            nullOrUndefinedCheck(params.facility) === null && 
            nullOrUndefinedCheck(params.recoveryActivity) === null && 
            nullOrUndefinedCheck(params.test) === null && 
            nullOrUndefinedCheck(params.etc) === null
          )
        ) {
          this.errorMsg()
          return
        }
        
        this.$store.dispatch(ACT_INSERT_YIELD_SPECIAL_NOTE, params).then((resp) =>{
          if(isSuccess(resp)){
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage, color: 'success'});
            this.specialNoteModal = false
            this.getSpecialNote()
          }else{
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
          }
        })
      },
      // 특이사항 조회
      getSpecialNote(){
        const params = {
          startYmd : this.specialNoteStartYmd,
          endYmd : this.specialNoteEndYmd,
          pageNo : this.specialNotePaging.pageNo,
          pageSize: this.specialNotePaging.pageSize
        }

        this.$store.dispatch(ACT_GET_YIELD_SPECIAL_NOTE, params).then((resp) =>{

          resp.items.forEach(item =>{
            item.specialNoteDate = timestampToDate(getTimeDifference(item.specialNoteDate, this.timeZone),'yyyy-MM-dd')
            item.createDt = timestampToDate(getTimeDifference(item.createDt, this.timeZone),'yyyy-MM-dd')
          })
          this.specialNoteItemList = resp.items;
          this.specialNotePaging.totalCount = resp.paging.totalCount
        })
      },
      // 특이사항 수정
      updateSpecialNote() {
        let params = {
          specialNoteDate : this.specialNoteDate,
          fno: this.fno,
          growth : this.growth,
          facility : this.facility,
          recoveryActivity : this.recoveryActivity,
          test : this.test,
          etc : this.etc
        }
        // 유효성 검증
        if(nullOrUndefinedCheck(params.specialNoteDate) === null || 
          (
            nullOrUndefinedCheck(params.growth) === null && 
            nullOrUndefinedCheck(params.facility) === null && 
            nullOrUndefinedCheck(params.recoveryActivity) === null && 
            nullOrUndefinedCheck(params.test) === null && 
            nullOrUndefinedCheck(params.etc) === null
          )
        ) {
          this.errorMsg()
          return
        }

        this.$store.dispatch(ACT_UPDATE_YIELD_SPECIAL_NOTE, {specialNoteNo: this.specialNoteNo, params: params}).then((resp) =>{
          if(isSuccess(resp)){
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage, color: 'success'});
            this.specialNoteModal = false
            this.getSpecialNote()
          }else{
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
          }
        })
      },
      // 특이사항 삭제
      deleteSpecialNote() {

        const yesCallback = () => {

          this.$store.dispatch(ACT_DELETE_YIELD_SPECIAL_NOTE, this.specialNoteNo).then((resp) =>{
            if(isSuccess(resp)){
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage, color: 'success'});
              this.specialNoteModal = false
              this.getSpecialNote()
            }else{
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
            }
          }).catch(e => {
            console.error(e);
            this.$store.dispatch(ACT_ADD_ALERT, {message: this.i18n.error});
          });
        }

        this.$store.dispatch(ACT_SHOW_CONFIRM_ALERT, {
          info: {title: this.i18n.deleteAlert},
          callback: yesCallback
        })

      },
      // 특이사항 row 클릭
      specialNoteClick(item) {
        this.specialNoteModal = true
        this.specialNoteDate = item.specialNoteDate
        this.specialNoteNo = item.specialNoteNo
        this.growth = item.growth
        this.facility = item.facility
        this.recoveryActivity = item.recoveryActivity
        this.test = item.test
        this.etc = item.etc
        this.comment = item.comment
      },
      // 실적 엑셀 다운
      onDownloadExcel(){
        
        const params = {
          startYmd : this.managementYmd.startYmd,
          endYmd : this.managementYmd.endYmd,
          pageNo : 1,
          pageSize: 99999,
          cropNo : this.filterCrop.cropNo
        }
        this.$store.dispatch(ACT_GET_YIELD_MANAGEMENT, params).then((resp) =>{
          resp.items.forEach(item => {
            item.growingDays = this.getGrowingDays(item)
          })

          this.managementListExcel = resp.items;
          this.$nextTick(() => {
            const table = document.getElementById('yield_table');
            if (!table) {
              console.error("테이블이 존재하지 않습니다.");
              return;
            }

            const workSheet = XLSX.utils.table_to_sheet(table, {
              dateNF: 'yyyy/mm/dd',
              cellDates: true ,
              raw: true 
            });

            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, workSheet, 'sheet1');
            XLSX.writeFile(workBook, `${this.farmNm} 실적 ${this.managementYmd.startYmd}~${this.managementYmd.endYmd}.xlsx`);
          });
        })
      },
      // 특이사항 엑셀 다운
      onSpecialDownloadExcel(){

        const params = {
          startYmd : this.specialNoteStartYmd,
          endYmd : this.specialNoteEndYmd,
          pageNo : 1,
          pageSize: 99999
        }

        this.$store.dispatch(ACT_GET_YIELD_SPECIAL_NOTE, params).then((resp) =>{

          resp.items.forEach(item =>{
            item.specialNoteDate = timestampToDate(getTimeDifference(item.specialNoteDate, this.timeZone),'yyyy-MM-dd')
            item.createDt = timestampToDate(getTimeDifference(item.createDt, this.timeZone),'yyyy-MM-dd')
          })
          this.specialNoteItemListExcel = resp.items;

          this.$nextTick(() => {
            const table = document.getElementById('special_table');
            if (!table) {
              console.error("테이블이 존재하지 않습니다.");
              return;
            }

            const workSheet = XLSX.utils.table_to_sheet(table, {
              dateNF: 'yyyy/mm/dd',
              cellDates: true ,
              raw: true 
            });

            const workBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workBook, workSheet, 'sheet1');
            XLSX.writeFile(workBook, `${this.farmNm} 특이사항 ${this.specialNoteStartYmd}~${this.specialNoteEndYmd}.xlsx`);
          });

        })
        
   
        
      },
      // 기본으로 현재일자 셋팅
      setTodayDate(){
        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 1);
        this.specialNoteDate = utcToDate(currentDate, 'yyyy-MM-dd')
      },
      // 시작일 종료일 설정
      changeFixedDate(day) {
        let currentDate = new Date();
        const startDate = new Date(currentDate.setDate(currentDate.getDate() - day ));
        const startDateUTC = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()));
        this.managementYmd.startYmd = startDateUTC.toISOString().slice(0, 10)
        this.managementYmd.endYmd = utcToDate(new Date(), 'yyyy-MM-dd')
        this.specialNoteStartYmd = startDateUTC.toISOString().slice(0, 10)
        this.specialNoteEndYmd = utcToDate(new Date(), 'yyyy-MM-dd')
      },

      // 숫자수 제한
      limitNumber(model, limitValue) {
        if(this[model].length >= limitValue) {
          this[model] = this[model].slice(0,limitValue)
        }
      },
      // 숫자수 제한
      limitNumberObject(model,key, limitValue) {
        if(this[model][key].length >= limitValue) {
          this[model][key] = this[model][key].slice(0,limitValue)
        }
      },
      // 생산실적
      linkGen(pageNum) {
        return pageNum === 1 ? '?' : `?page=${pageNum}`
      },
      // 특이사항
      spcicalLinkGen(pageNum) {
        return pageNum === 1 ? '?' : `?specialNotePage=${pageNum}`
      },
      changeConnect(i){
        this.contentTap.tableState = i
        // URL 쿼리 초기화
        this.$router.push({ query: {} }).catch(()=>{});
      },
      // 오류창
      errorMsg(){
        let info = {}
        info.title = this.i18n.rightValue
        info.icon = 'error'
        info.focusConfirm = true
        info.confirmButtonColor = '#131628'
        info.confirmButtonText = this.i18n.confirm
        Vue.swal.fire(info)
      },
    }
  };
  
  </script>
  
  
<style scoped lang="scss">
  tr.v-data-table__expanded {
    background: #E4E6EF !important;
  }
  // 실적등록모달 내부 탭
  .performance-tabs {
    .nav-tabs {
      padding: 0 3.077rem; 
      border-bottom:0;
      // .nav-link { border-bottom:0 !important; }
      .nav-link.active, .nav-link:hover {
        .nav-text { 
          font-weight:border; 
        }
      }
    }
  }
  // 모바일 환경 시 테이블 깨짐 방지
  .v-data-table--mobile > .v-data-table__wrapper tbody {
    display: table-row-group !important; /* 테이블 기본 레이아웃 유지 */
  }
  // 비활성화 색
  .disabled-gray {
    background-color : #e9ecef !important;
  }
  // 활성화 색
  .disabled-white {
    background-color : white !important;
  }

  // 정식구역 스크롤바
  .scrollable-text {
    white-space: nowrap;        /* 텍스트 줄바꿈 방지 */
    overflow-x: auto;          /* X축 스크롤 활성화 */
    overflow-y: hidden;        /* Y축 스크롤 비활성화 */
    max-width: 100%;           /* 부모 요소의 너비 제한 */
    display: flex;             /* Flexbox 사용 */
    align-items: center;       /* 세로 가운데 정렬 */
    padding: 5px;              /* 내부 여백 추가 */
    box-sizing: border-box;    /* 여백과 테두리 포함 */
  }
  /* 스크롤바 스타일 */
  .scrollable-text::-webkit-scrollbar {
    height: 6px;               /* 스크롤바 높이 */
  }
  .scrollable-text::-webkit-scrollbar-thumb {
    background: #888;          /* 스크롤바 색상 */
    border-radius: 3px;        /* 스크롤바 모서리 둥글게 */
  }
  .scrollable-text::-webkit-scrollbar-thumb:hover {
    background: #555;          /* 마우스 오버 시 색상 변경 */
  }
  .scrollable-text::-webkit-scrollbar-track {
    background: #f1f1f1;       /* 스크롤바 트랙 색상 */
  }
  .scrollable-sticky {
    position: sticky;          /* 스크롤 시 고정 */
    top: 0;                    /* 화면 상단에 고정 */
    z-index: 10;               /* 다른 요소보다 위에 표시되도록 설정 */
  }

  // 특이사항 테이블 넒이 조절
  .text-truncate {
    max-width: 100px; /* 필요에 따라 조정 */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  // 텍스트 넘침 줄바꿈
  span.h5 {
    white-space: normal;
  }
  th {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
  }

  .farm-data-table td {
    background-color: #fff;
  }
  
.sticky-col-0 {
  position: sticky;
  left: 0;
  z-index: 10;
}

.sticky-col-1 {
  position: sticky;
  left: 100px; /* 실제 0번 열의 너비 */
  z-index: 9;
}

/* 1열 고정 */
.farm-data-table td:nth-child(1) {
  position: sticky;
  left: 0;
  z-index: 3; /* 헤더가 셀보다 위에 오게 하려면 적절히 설정 */
}

/* 2열 고정 */
.farm-data-table td:nth-child(2) {
  position: sticky;
  left: 100px; /* 1열의 너비만큼 옮김 (정확한 값은 실제 th/td width에 맞게 조절) */
  z-index: 2; /* 1열보다 아래, 일반 셀보다 위 */
}





</style>